import React from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
export const VerticalHeadTable = (props) => {
    const { data } = props;
    return (React.createElement(TableContainer, null,
        React.createElement(Table, null,
            React.createElement(TableBody, null, data.map((obj) => {
                return (React.createElement(TableRow, { key: obj.th },
                    React.createElement(TableCell, { component: "th", scope: "row", style: { width: '140px' } }, obj.th),
                    React.createElement(TableCell, null, obj.td)));
            })))));
};
